<template>
  <div class="page padding">
    <b-row>
      <b-col md="6" class="body">
        <img v-bind:src="'img/icons/RC/RC_1.3.svg'" class="icon" />
        <p>Rc Profesional</p>
        <p>Flyers de Descripción de Coberturas</p>
        <p>Armas de Fuego</p>
        <b-button class="button" @click="openPDF('Armas de Fuego.pdf')" style="background-color: #632c43">TENEDOR ARMAS DE FUEGO</b-button><br />
        <b-button class="button" @click="openPDF('Armas de Fuego.pdf')" style="background-color: #773c52">PORTADOR DE ARMAS DE FUEGO</b-button><br />
        <b-button class="button" @click="openPDF('Armas de Fuego.pdf')" style="background-color: #a15772">COTO DE CAZA & POLIGONO DE TIRO</b-button><br />
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pdf_url: 'http://nobleonline.nobleseguros.com/be/recursos/RCP/ARMAS DE FUEGO/',
    };
  },
  methods: {
    openPDF(pdf) {
      window.open(this.pdf_url + pdf);
    },
  },
};
</script>

<style scoped>
.body {
  color: #632c43;
  max-width: 400px;
  font-weight: bold;
  font-size: 12pt;
}
.icon {
  filter: invert(88%) sepia(14%) saturate(4284%) hue-rotate(318deg) brightness(110%) contrast(90%);
  width: 60%;
  margin-bottom: 15px;
}

@media (max-width: 576px) {
  .icon {
    margin-right: auto;
    display: block;
    margin-left: auto;
    width: 50%;
    margin-bottom: 15px;
  }
}

.button {
  width: 100%;
  text-align: left;
  font-weight: bold;
}

.button:hover{
  color:#ffffff;
}
</style>